import Highlight from "../components/Highlight";
import List from "../components/List";
import useService from "../hooks/useServices";

const Closets = () => {
  const { service } = useService({ type: "closets" });

  return (
    <>
      <Highlight img="about" size="tiny" />
      <List list={service} type="closets" />
    </>
  );
};

export default Closets;